export async function buscaCep(cep,form)
{
  const validacep = /^[0-9]{5}-?[0-9]{3}$/;

  const _setValues = (logradouro, bairro) => {
    // So sobrescreve o que veio preenchido: CEP unico de municipio (comum em cidade pequena) volta sem
    // logradouro/bairro, e no painel de curriculo esses campos ja chegam com o endereco salvo do candidato.
    if (logradouro)
      form.querySelector('input[data-buscacep="logradouro"]').value = logradouro;
    if (bairro)
      form.querySelector('input[data-buscacep="bairro"]').value = bairro;
  };
  
  const callbackSucesso = (dados) =>{
    _setValues(dados.logradouro, dados.bairro);
  };

  const callbackErro = (dados) =>{
  };

  if (typeof cep != 'undefined' && cep != '' && validacep.test(cep)){
    const response = await fetch('/Home/BuscarCep?cep=' + cep);
    if (response.status != 200) {
      callbackErro();
      return;
    }
    const jsonData = await response.json();
      if (jsonData.erro) {
          return;
      }
    callbackSucesso(jsonData);
    // Devolve undefined quando o CEP e invalido/nao encontrado. O painel de curriculo usa cidadeID/estadoID
    // do retorno para acertar os selects em cascata, que nao existem nas demais telas.
    return jsonData;
  }
}
